import { React, useState, useEffect, useContext, Fragment } from "react";
import { AppContext } from '../../../AppStore';
import styles from "./MOB_Main.module.css";
import '../../Layout/theme.css'
import axios from "axios";
import { Chart } from "react-google-charts";
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import Moment from 'moment';
import "moment/locale/ko";
import { isBrowser, isIOS, isAndroid, isMobile } from 'react-device-detect';
import GridNoRow from '../../../common/GridNoRow';
import { CircularProgress, Fade } from '@mui/material';

const MOB_Main = () => {
    const appStore = useContext(AppContext);
    const [screenWidth, setScreenWidth] = useState('360px');
    const navigate = useNavigate();
    const mobileDetailRouteMap = {
        order: (id) => `/m/order_detail/${id}`,
        purchase: (id) => `/m/purchase_detail/${id}`,
        incoming: (id) => `/m/incoming_detail/${id}`,
        outgoing: (id) => `/m/outgoing_detail/${id}`,
        quality_measurement: (id) => `/m/quality_measurement_detail/${id}`,
    };
    const handleRowClick = (type) => (params) => {
        const id = params?.row?.id ?? params?.id;
        if (!id) return;
        const builder = mobileDetailRouteMap[type];
        if (!builder) return;
        navigate(builder(id));
    };
    const mainScreenType = String(localStorage.getItem("main_screen_type"));
    const [rowStock, setRowStock] = useState([]);
    const [columnStock, setColumnStock] = useState([
        { field: 'id', headerName: 'item_id', width: 0, headerAlign: 'center' },
        { field: 'item_data', headerName: '품목정보', width: 300, headerAlign: 'center', align:'left' },
        { field: 'dp_stock', headerName: '재고', width: 130, headerAlign: 'center', align:'right' },
        { field: 'dp_use_stock', headerName: '사용가능재고', width: 170, headerAlign: 'center', align:'right' }
    ]);
    const [rowOrder, setRowOrder] = useState([]);
    const [columnOrder, setColumnOrder] = useState([
        { field: 'id', headerName: 'order_id', width: 0, headerAlign: 'center' },
        { field: 'order_data', headerName: '수주정보', width: 375, headerAlign: 'center', align:'left' }
    ]);
    const [rowPurchase, setRowPurchase] = useState([]);
    const [columnPurchase, setColumnPurchase] = useState([
        { field: 'id', headerName: 'purchase_id', width: 0, headerAlign: 'center' },
        { field: 'purchase_data', headerName: '발주정보', width: 375, headerAlign: 'center', align:'left' }
    ]);
    const [rowIncoming, setRowIncoming] = useState([]);
    const [columnIncoming, setColumnIncoming] = useState([
        { field: 'id', headerName: 'incoming_id', width: 0, headerAlign: 'center' },
        { field: 'incoming_data', headerName: '입고정보', width: 375, headerAlign: 'center', align:'left' }
    ]);
    const [rowOutgoing, setRowOutgoing] = useState([]);
    const [columnOutgoing, setColumnOutgoing] = useState([
        { field: 'id', headerName: 'outgoing_id', width: 0, headerAlign: 'center' },
        { field: 'outgoing_data', headerName: '출하정보', width: 375, headerAlign: 'center', align:'left' }
    ]);
    const [rowQualityMeasurement, setRowQualityMeasurement] = useState([]);
    const [columnQualityMeasurement, setColumnQualityMeasurement] = useState([
        { field: 'id', headerName: 'quality_measurement_id', width: 0, headerAlign: 'center' },
        { field: 'quality_measurement_data', headerName: '품질측정정보', width: 375, headerAlign: 'center', align:'left' }
    ]);
    const [machine, setMachine] = useState([]);
    
    const formatTime = (timeStr) => {
        if (!timeStr) return '-';
        const parts = timeStr.split(':');
        if (parts.length !== 3) return timeStr;
        return `${parts[0]}H ${parts[1]}M ${parts[2]}S`;
    };
    
    const MainSearch = () => {
        if(String(mainScreenType) === '1'){
            axios.get('/api/p/MachineMonitoring/Select')
            .then((response) => {
                var machineInfo = []
                for(let i = 0; i < response.data.length; i++) {
                    let data = response.data[i]
                    let temp_percent = 0;
                    let temp_percent_color = 'white'
                    let temp_status_run = data.status_run !== undefined ? data.status_run : data.status;
                    let temp_status_run_name = ''
                    let temp_status_run_color = 'white'
                    let temp_status_aut = data.status_aut;
                    let temp_status_aut_name = ''
                    
                    if(data.machine_type == '1'){
                        if(Number(data.sum_produce_count) > 0){
                            if (data.target_count > 0) {
                                temp_percent = Math.floor((data.produce_count / data.target_count) * 100);
                            }

                            if (temp_percent >= 100) {
                                temp_percent = 100;
                                temp_percent_color = 'rgb(90, 150, 70)';   // 안정 (그린)
                            }
                            if (temp_percent <= 50) {
                                temp_percent_color = 'rgb(200, 80, 80)';   // 위험 (레드)
                            } else if (temp_percent > 50 && temp_percent <= 80) {
                                temp_percent_color = 'rgb(210, 140, 60)';  // 주의 (오렌지)
                            } else if (temp_percent > 80 && temp_percent <= 99) {
                                temp_percent_color = 'rgb(160, 150, 80)';  // 거의 안정 (카키)
                            }
                        }
                        
                        const temp_start = Moment(data.start_datetime).format('YYYY-MM-DD HH:mm:ss');
                        const temp_now = Moment().format('YYYY-MM-DD HH:mm:ss');
                        const str_start = Moment(temp_start)
                        const str_now = Moment(temp_now)
                        const duration = Moment.duration(str_now.diff(str_start));

                        let hours = (duration.days()*24)+duration.hours();
                        let minutes = duration.minutes();
                        if(minutes < 10){minutes='0'+minutes}
                        let seconds = duration.seconds();
                        if(seconds < 10){seconds='0'+seconds}
                        
                        // 가동상태
                        if(temp_status_run == 0){
                            temp_status_run_name = '오프라인'
                            temp_status_run_color = 'rgb(57, 54, 54)'
                        } else if (temp_status_run == 1){
                            temp_status_run_name = '정지'
                            temp_status_run_color = '#D84B16'
                        } else if (temp_status_run == 2){
                            temp_status_run_name = '홀드'
                            temp_status_run_color = '#FFB737'
                        } else if (temp_status_run == 3){
                            temp_status_run_name = '가동'
                            temp_status_run_color = 'rgb(104, 171, 38)'
                        } else if (temp_status_run == 4){
                            temp_status_run_name = 'MSTR'
                            temp_status_run_color = '#F1A7C9'
                        } else if (temp_status_run == -1){
                            temp_status_run_name = '미 연결'
                            temp_status_run_color = 'rgba(100,116,139,.5)'
                        } else {
                            temp_status_run_name = ''
                            temp_status_run_color = '#bdbdbd'
                        }

                        // 가동모드
                        if(temp_status_aut == '0'){
                            temp_status_aut_name = "MDI"
                        } else if (temp_status_aut == '10' || temp_status_aut == '2' || temp_status_aut == '6' || temp_status_aut == '7' || temp_status_aut == '8') {
                            temp_status_aut_name = "ETC"
                        } else if (temp_status_aut == '3') {
                            temp_status_aut_name = "EDIT"
                        } else if (temp_status_aut == '4') {
                            temp_status_aut_name = "HND"
                        } else if (temp_status_aut == '5') {
                            temp_status_aut_name = "JOG"
                        } else if (temp_status_aut == '9') {
                            temp_status_aut_name = "REF"
                        } else if (temp_status_aut == '1') {
                            temp_status_aut_name = "MEM"
                        } else if (temp_status_aut == -1){
                            temp_status_aut_name = '미 연결'
                        } else {
                            temp_status_aut_name = ""
                            temp_status_aut_name = ""
                        }
                    }else if(data.machine_type == '2' || data.machine_type == '4'){
                        if(Number(data.sum_produce_count) > 0){
                            temp_percent = Math.floor((data.sum_produce_count / data.target_count) * 100);

                            if (temp_percent >= 100) {
                                temp_percent = 100;
                                temp_percent_color = 'rgb(90, 150, 70)';   // 안정 (그린)
                            }
                            if (temp_percent <= 50) {
                                temp_percent_color = 'rgb(200, 80, 80)';   // 위험 (레드)
                            } else if (temp_percent > 50 && temp_percent <= 80) {
                                temp_percent_color = 'rgb(210, 140, 60)';  // 주의 (오렌지)
                            } else if (temp_percent > 80 && temp_percent <= 99) {
                                temp_percent_color = 'rgb(160, 150, 80)';  // 거의 안정 (카키)
                            }
                        }

                        if(temp_status_run == 0){
                            temp_status_run_name = '정지'
                            temp_status_run_color = '#D84B16'
                        } else if (temp_status_run == 1){
                            temp_status_run_name = '가동'
                            temp_status_run_color = 'rgb(104, 171, 38)'
                        } else if (temp_status_run == -1){
                            temp_status_run_name = '미 연결'
                            temp_status_run_color = 'rgba(100,116,139,.5)'
                        } else {
                            temp_status_run_name = ''
                            temp_status_run_color = '#bdbdbd'
                        }
                    } else if (data.machine_type == '5') {
                        /* 🚨 추가: TYPE 5 모바일 가동상태 및 색상 맵핑 */
                        if (temp_status_run == 1) {
                            temp_status_run_name = '가동'; temp_status_run_color = 'rgb(104, 171, 38)';
                        } else if (temp_status_run == 0) {
                            temp_status_run_name = '정지'; temp_status_run_color = '#D84B16';
                        } else if (temp_status_run == -1) {
                            temp_status_run_name = '미 연결'; temp_status_run_color = 'rgba(100,116,139,.5)';
                        } else {
                            temp_status_run_name = ''; temp_status_run_color = '#bdbdbd';
                        }
                    }
                    
                    /* 🚨 추가: TYPE 5 데이터도 push 배열에 명시적으로 포함되도록 조건 수정 및 데이터 맵핑 */
                    if (['1', '2', '4', '5'].includes(String(data.machine_type))) {
                        machineInfo.push(
                            {
                                machine_id: data.machine_id,
                                machine_name: data.machine_name,
                                machine_type: data.machine_type,
                                machine_max_datetime: data.max_datetime,
                                target_count: typeof data.target_count === 'undefined'? "0" : data.target_count,
                                produce_count: typeof data.produce_count === 'undefined'? "0": data.produce_count,
                                project_number: typeof data.project_number === 'undefined' ? "" : data.project_number,
                                project_name: typeof data.project_name === 'undefined' ? "" : data.project_name,
                                progress_percent: typeof data.produce_count === 'undefined' && typeof data.sum_produce_count === 'undefined'? "0" : temp_percent,
                                progress_percent_color: temp_percent_color,
                                run_status: temp_status_run_name,
                                run_color:temp_status_run_color,
                                aut_status: temp_status_aut_name,
                                sum_produce_time: data.sum_produce_time,
                                sum_produce_count: data.sum_produce_count,
                                sum_ok_count: typeof data.sum_ok_count === 'undefined'? "0" : data.sum_ok_count,
                                sum_ng_count: typeof data.sum_ng_count === 'undefined'? "0" : data.sum_ng_count,
                                ng1_count: typeof data.ng1_count === 'undefined'? "0" : data.ng1_count,
                                ng2_count: typeof data.ng2_count === 'undefined'? "0" : data.ng2_count,
                                ng3_count: typeof data.ng3_count === 'undefined'? "0" : data.ng3_count,
                                ng1_label: typeof data.ng1_label === 'undefined'? "" : data.ng1_label,
                                ng2_label: typeof data.ng2_label === 'undefined'? "" : data.ng2_label,
                                ng3_label: typeof data.ng3_label === 'undefined'? "" : data.ng3_label,
                                raw_cut_time: (typeof data.raw_cut_time === 'undefined' ? "" : data.raw_cut_time),
                                raw_cycle_time: (typeof data.raw_cycle_time === 'undefined' ? "" : data.raw_cycle_time),
                                raw_general_cut_time: (typeof data.raw_general_cut_time === 'undefined' ? "" : data.raw_general_cut_time),
                                raw_model: (typeof data.raw_model === 'undefined' ? "" : data.raw_model),
                                raw_part: (typeof data.raw_part === 'undefined' ? "" : data.raw_part),
                                raw_run_time: (typeof data.raw_run_time === 'undefined' ? "" : data.raw_run_time),
                                raw_target_part: (typeof data.raw_target_part === 'undefined' ? "" : data.raw_target_part),
                                raw_total_part: (typeof data.raw_total_part === 'undefined' ? "0" : data.raw_total_part),
                                raw_total_time: (typeof data.raw_total_time === 'undefined' ? "" : data.raw_total_time),
                                raw_type: (typeof data.raw_type === 'undefined' ? "" : data.raw_type),
                                // Modbus 데이터 맵핑
                                val1: data.val1, val1_name: data.val1_name,
                                val2: data.val2, val2_name: data.val2_name,
                                val3: data.val3, val3_name: data.val3_name,
                                val4: data.val4, val4_name: data.val4_name,
                                val5: data.val5, val5_name: data.val5_name,
                                val6: data.val6, val6_name: data.val6_name,
                                val7: data.val7, val7_name: data.val7_name,
                                val8: data.val8, val8_name: data.val8_name,
                                val9: data.val9, val9_name: data.val9_name,
                            }
                        );
                    }
                }
                setMachine(machineInfo);
            });
        }
    };

    const CommonSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/Common/Main')
        .then((response) => {
            let stockArray = response.data.map((item, index) => ({
                id: item.item_id,
                item_data: item.item_name + ' ' +appStore.ITEM_FULL_SPEC_MAKE( item.item_spec, item.item_width, item.item_depth, item.item_height),
                dp_stock: item.dp_stock,
                dp_use_stock: item.dp_use_stock
            }));
            stockArray = stockArray.filter((item, index) => {
                return typeof item.id !== 'undefined';
            });

            let orderArray = response.data.map((item, index) => ({
                id: item.order_id,
                order_data: item.order_data
            }));
            orderArray = orderArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });

            let purchaseArray = response.data.map((item, index) => ({
                id: item.purchase_id,
                purchase_data: item.purchase_data
            }));
            purchaseArray = purchaseArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });

            let incomingArray = response.data.map((item, index) => ({
                id: item.incoming_id,
                incoming_data: item.incoming_data
            }));
            incomingArray = incomingArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });

            let outgoingArray = response.data.map((item, index) => ({
                id: item.outgoing_id,
                outgoing_data: item.outgoing_data
            }));
            outgoingArray = outgoingArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });

            let qualityMeasurementArray = response.data.map((item, index) => ({
                id: item.quality_measurement_id,
                quality_measurement_data: item.quality_measurement_data + ' ' + (typeof item.quality_measurement_value === 'undefined'?item.quality_measurement_option_name:item.quality_measurement_value)  + ' (' + item.quality_measurement_result + ') / ' + item.quality_measurement_user_name
            }));
            qualityMeasurementArray = qualityMeasurementArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });
            
            setRowOrder(orderArray);
            setRowPurchase(purchaseArray);
            setRowIncoming(incomingArray);
            setRowOutgoing(outgoingArray);
            setRowQualityMeasurement(qualityMeasurementArray);
            setRowStock(stockArray);
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    };

    useEffect(() => {
        if(isMobile){
            setScreenWidth(String(Number(window.innerWidth) - 35)+'px')
        }else{
            setScreenWidth('100%')
        }
        
        if (appStore.loading) return;
        appStore.setLoading(true);

        try {
            MainSearch();
            CommonSearch();
        } finally {
            appStore.setLoading(false);
        }

        // 🔄 30초마다 MainSearch 실행
        const interval = setInterval(() => {
            MainSearch();
        }, 30000);

        // 언마운트 시 정리
        return () => clearInterval(interval);
    }, []);
   
    return (
        <div style={{ width:'100vw', minHeight:'auto', background:'var(--bg)', padding: 0, margin: 0, position: 'relative' }}>
            {mainScreenType === '1'?
            <>
            <div className={styles.bigCardGrid}>
                {machine.map((item, index) => (
                    <div key={index} className={`${styles.card} ${styles.bigCard}`}>
                        <div style={{ flex: 1, width: '100%' }}>
                            <div style={{ border: '3px solid #bdbdbd', width: '100%', boxSizing: 'border-box' }}>
                                <div style={ { height: '36px', backgroundColor: `${item.run_color}`, padding: '3px' } }>
                                    <div style={{float: 'left', fontWeight: 'bold', fontSize: '22px', color: 'white'}}>
                                        {item.machine_name}
                                    </div>
                                    <div style={{float: 'right', fontWeight: 'bold', fontSize: '18px', color: 'white', paddingTop: '5px'}}>
                                        {item.project_name?.trim() ? item.project_name : item.run_status + ' [ '+item.machine_max_datetime+' ]' }
                                    </div>
                                </div>
                                {((item.machine_type == '4' && item.target_count > 0 && item.sum_produce_count > 0) || (item.machine_type == '1' && item.produce_count > 0 && item.target_count > 0 && item.sum_produce_count > 0))?
                                <>
                                {/* 생산 카운트 */}
                                {(item.machine_type == '1')?
                                <div style={{ height: '30px', padding: '5px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>
                                    <span>{Number(item.produce_count).toLocaleString()} / {Number(item.target_count).toLocaleString()}</span>
                                </div>
                                :
                                (item.machine_type == '4')?
                                <div style={{ height: '30px', padding: '5px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>
                                    <span>{Number(item.sum_produce_count).toLocaleString()} / {Number(item.target_count).toLocaleString()}</span>
                                </div>
                                :<></>}

                                {/* 진행바 + 퍼센트 */}
                                <div className="progress-row">
                                    <div className="progress-shell">
                                        <div className="progress-track">
                                            <i style={{ width: `${item.progress_percent}%`, background: item.progress_percent_color }} />
                                        </div>
                                    </div>
                                    <div className="progress-label">
                                        {item.progress_percent}%
                                    </div>
                                </div>
                                </>
                                :
                                <>
                                {(item.machine_type == '2')?
                                <div style={ { height: '146px', padding: '3px', textAlign:'center', fontWeight: 'bold', paddingTop: '25px' } }>
                                    <span className={`badge ${
                                        item.run_status === "가동"   ? "run" :
                                        item.run_status === "정지"     ? "stop" :
                                        item.run_status === "홀드"     ? "hold" :
                                        item.run_status === "오프라인" ? "offline" :
                                        item.run_status === "MSTR"    ? "mstr" :
                                        item.run_status === "미 연결"    ? "notconnect" :
                                        "etc"
                                    }`} style={ { width: '300px', height: '100px', fontSize: '58px' } }>
                                        {item.run_status}
                                    </span>
                                </div>
                                :
                                (item.machine_type == '1')?
                                null
                                :
                                /* 🚨 TYPE 5 모바일용 가동상태 레이아웃 바인딩 (TYPE 4와 동일 스타일 유지) */
                                <div style={ { height: '70px', padding: '3px', textAlign:'center', fontWeight: 'bold', paddingTop: '8px' } }>
                                    <span className={`badge ${
                                        item.run_status === "가동"   ? "run" :
                                        item.run_status === "정지"     ? "stop" :
                                        item.run_status === "홀드"     ? "hold" :
                                        item.run_status === "오프라인" ? "offline" :
                                        item.run_status === "MSTR"    ? "mstr" :
                                        item.run_status === "미 연결"    ? "notconnect" :
                                        "etc"
                                    }`} style={ { width: '300px', height: '55px', fontSize: '32px' } }>
                                        {item.run_status}
                                    </span>
                                </div>}
                                </>
                                }
                                <div style={{ textAlign:'center', padding: '3px', paddingTop: '3px' }}>
                                    {(item.machine_type == '1')?
                                    <table className="machine-table" style={{width:'100%'}}>
                                        <colgroup>
                                            <col style={{width: '40%'}} />
                                            <col style={{width: '60%'}} />
                                        </colgroup>
                                        <tbody>
                                        <tr>
                                            <td className="label">상태</td>
                                            <td className="value" style={{paddingTop: '0px', paddingBottom: '0px'}}>
                                            <span className={`badge ${
                                                item.run_status === "가동"   ? "run" :
                                                item.run_status === "정지"     ? "stop" :
                                                item.run_status === "홀드"     ? "hold" :
                                                item.run_status === "오프라인" ? "offline" :
                                                item.run_status === "MSTR"    ? "mstr" :
                                                item.run_status === "미 연결"    ? "notconnect" :
                                                "etc"
                                            }`}>{item.run_status}</span>
                                            &nbsp;
                                            <span className={`badge ${
                                                item.aut_status === "MDI"  ? "mdi" :
                                                item.aut_status === "MEM"  ? "mem" :
                                                item.aut_status === "EDIT" ? "edit" :
                                                item.aut_status === "HND"  ? "hnd" :
                                                item.aut_status === "JOG"  ? "jog" :
                                                item.aut_status === "REF"  ? "ref" :
                                                item.aut_status === "ETC"  ? "etc-mode" :
                                                item.aut_status === "미 연결"   ? "notconnect" :
                                                "etc-mode"
                                            }`}>{item.aut_status}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="label">{`${new Date().getMonth()+1}월 ${new Date().getDate()}일 가공`}</td>
                                            <td className="value">{item.sum_produce_count} [{formatTime(item.sum_produce_time)}]</td>
                                        </tr>
                                        <tr>
                                            <td className="label">소요부품수</td>
                                            <td className="value num">{item.raw_target_part ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="label">가공부품수</td>
                                            <td className="value num">{item.raw_part ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="label">가공부품전체수</td>
                                            <td className="value num">{item.raw_total_part}</td>
                                        </tr>
                                        <tr>
                                            <td className="label">운전시간</td>
                                            <td className="value">{formatTime(item.raw_run_time) || '-'}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    :
                                    (item.machine_type == '4')?
                                    <table className="machine-table" style={{ width: "100%", tableLayout: "fixed" }}>
                                        <colgroup>
                                            {Array.from({ length: 12 }).map((_, i) => (
                                            <col key={i} style={{ width: "8.3333%" }} />
                                            ))}
                                        </colgroup>
                                        <tbody>
                                            <tr style={{ height: "35px" }}>
                                            <td className="label" style={{ color: "blue" }} colSpan={3}>OK</td>
                                            <td className="value num" colSpan={3}>{Number(item.sum_ok_count).toLocaleString()}</td>
                                            <td className="label" style={{ color: "red" }} colSpan={3}>NG</td>
                                            <td className="value num" colSpan={3}>{Number(item.sum_ng_count).toLocaleString()}</td>
                                            </tr>
                                            <tr style={{ height: "39px" }}>
                                            <td colSpan={4} style={{ padding: 0 }}>
                                                <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                                <div className="label" style={{ flex: "5 1 0", minWidth: 0, padding: "3px", fontSize: "12px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.ng1_label}</div>
                                                <div className="value num" style={{ flex: "2 1 0", padding: "3px", fontSize: "12px", textAlign: "right" }}>{item.ng1_count}</div>
                                                </div>
                                            </td>
                                            <td colSpan={4} style={{ padding: 0 }}>
                                                <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                                <div className="label" style={{ flex: "5 1 0", minWidth: 0, padding: "3px", fontSize: "12px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.ng2_label}</div>
                                                <div className="value num" style={{ flex: "2 1 0", padding: "3px", fontSize: "12px", textAlign: "right" }}>{item.ng2_count}</div>
                                                </div>
                                            </td>
                                            <td colSpan={4} style={{ padding: 0 }}>
                                                <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                                <div className="label" style={{ flex: "5 1 0", minWidth: 0, padding: "3px", fontSize: "12px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.ng3_label}</div>
                                                <div className="value num" style={{ flex: "2 1 0", padding: "3px", fontSize: "12px", textAlign: "right" }}>{item.ng3_count}</div>
                                                </div>
                                            </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    :
                                    (item.machine_type == '5')?
                                    /* 🚨 추가: TYPE 5 모바일 전용 3열 압축 테이블 (Flex 내부 분배로 좁은 화면 최적화) */
                                    <table className="machine-table" style={{ width: "100%", tableLayout: "fixed" }}>
                                        <colgroup>
                                            <col style={{ width: "33.3333%" }} />
                                            <col style={{ width: "33.3333%" }} />
                                            <col style={{ width: "33.3333%" }} />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const validItems = [1, 2, 3, 4, 5, 6, 7, 8, 9]
                                                    .map(num => ({
                                                        num,
                                                        name: item[`val${num}_name`],
                                                        val: item[`val${num}`]
                                                    }))
                                                    .filter(x => x.name || (x.val !== null && x.val !== undefined));

                                                if (validItems.length === 0) return null;

                                                const chunks = [];
                                                for (let i = 0; i < validItems.length; i += 3) {
                                                    const chunk = validItems.slice(i, i + 3);
                                                    while (chunk.length < 3) {
                                                        chunk.push({ num: '', name: '', val: '' });
                                                    }
                                                    chunks.push(chunk);
                                                }

                                                return chunks.map((chunk, rowIdx) => (
                                                    <tr key={rowIdx} style={{ height: "39px" }}>
                                                        {chunk.map((c, cIdx) => (
                                                            <td key={cIdx} style={{ padding: 0, border: c.name || c.val !== '' ? undefined : 'none' }}>
                                                                {(c.name || c.val !== '') ? (
                                                                    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                                                        <div className="label" style={{ flex: "5 1 0", minWidth: 0, padding: "3px", fontSize: "11px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                            {c.name || `데이터${c.num}`}
                                                                        </div>
                                                                        <div className="value num" style={{ flex: "3 1 0", padding: "3px", fontSize: "13px", fontWeight: "bold", textAlign: "right", color: "#111" }}>
                                                                            {c.val !== undefined && c.val !== null && c.val !== '' ? c.val : '-'}
                                                                        </div>
                                                                    </div>
                                                                ) : null}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ));
                                            })()}
                                        </tbody>
                                    </table>
                                    :
                                    <></>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            </>
            :
            <></>
            }
            {/* 아래 기존 6개 카드뉴스 */}
            <div className={styles.smallCardGrid}>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h3 className={styles.smallCardTitle}>품목재고</h3>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowStock}
                            columns={columnStock}
                            rowHeight={52}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '15px',
                                  fontWeight: 'bold'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>수주정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowOrder}
                            columns={columnOrder}
                            rowHeight={52}
                            onRowClick={handleRowClick('order')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '15px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>발주정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowPurchase}
                            columns={columnPurchase}
                            rowHeight={52}
                            onRowClick={handleRowClick('purchase')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '15px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>입고정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowIncoming}
                            columns={columnIncoming}
                            rowHeight={52}
                            onRowClick={handleRowClick('incoming')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '15px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>출하정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowOutgoing}
                            columns={columnOutgoing}
                            rowHeight={52}
                            onRowClick={handleRowClick('outgoing')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '15px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>품질측정정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowQualityMeasurement}
                            columns={columnQualityMeasurement}
                            rowHeight={52}
                            onRowClick={handleRowClick('quality_measurement')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '15px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MOB_Main;